import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CommonFileUploadComponent } from './common-file-upload.component';
import { FileUploadModule } from 'ng2-file-upload';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';;
import { CommonFileUploadPdfComponent } from './common-file-upload-pdf/common-file-upload-pdf.component';
import { CommonFileUploadVideoComponent } from './common-file-upload-video/common-file-upload-video.component';
import { CommonFileUploadAudioComponent } from './common-file-upload-audio/common-file-upload-audio.component';
@NgModule({
  declarations: [CommonFileUploadComponent,CommonFileUploadPdfComponent, CommonFileUploadVideoComponent, CommonFileUploadAudioComponent],
  imports: [
    CommonModule,
    FileUploadModule,
    MatProgressBarModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatButtonModule,
    CustomFlexLayoutModule
  ],
  exports:[CommonFileUploadComponent,CommonFileUploadPdfComponent,CommonFileUploadVideoComponent, CommonFileUploadAudioComponent]
})
export class CommonFileUploadModule { }
